import React from 'react';
import pt from 'prop-types';
import { useHolidayPackage } from './HolidayHooks';
import useOptions from '../../hooks/useOptions';
import styles from './HolidayDisplay.module.scss';
import bannerImg from './banner-image.jpg';
import HolidayOption from './HolidayOption';
import useHolidayPoses from '../../hooks/useHolidayPoses';
import useStudent from '../../hooks/useStudent';

export default function HolidayDisplay({ schoolId, studentId }) {
  const { data: pricelist } = useHolidayPackage({ schoolId });
  const { data: options } = useOptions(pricelist?.id, schoolId);
  const { data: student } = useStudent({ studentId, schoolId, isEnrolled: true });
  const { data: poses } = useHolidayPoses(student?.id);

  return (
    <div className={styles.page}>
      <div className={styles.bannerImgWrapper}>
        <div className={styles.bannerOverlay} />
        <img alt="Holiday Time" className={styles.bannerImg} src={bannerImg} />
      </div>
      <div className={styles.holidayOptions}>
        {options.map((option) => (
          <HolidayOption option={option} schoolId={schoolId} />
        ))}
      </div>
    </div>
  );
}

HolidayDisplay.propTypes = {
  schoolId: pt.oneOfType([pt.number, pt.string]).isRequired,
  studentId: pt.oneOfType([pt.number, pt.string]).isRequired,
};
